import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBatchRecordList, getBatchRecord } from "src/store/modelLifeCycleGroundTruthSlice";
import { getModelById, setSelectedModelId } from "src/store/modelManagementSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import "./batchRecordReview.scss";
import ReviewHeader from "src/components/shared/groundTruth/reviewHeader/reviewHeader";
import Divider from "@amzn/meridian/divider";
import ReviewText from "src/components/shared/groundTruth/reviewText/reviewText";
import ReviewTable from "src/components/shared/groundTruth/reviewTable/reviewTable";
import { getBatchJobById } from "src/store/batchExtractionSlice";
import {
  usePostUpdateNavigation,
  useGroundTruthDataEffects,
  useListViewEffects,
  useNavigationHandlers,
  useSaveHandler,
} from "src/components/shared/groundTruth/groundTruthReviewUtils";

const BatchRecordReview = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { token } = useAppSelector((state) => state.user);
  const { getListViewLoading } = useAppSelector((state) => state.modelLifeCycleGroundTruthSlice);

  const { selectedModel, selectedModelId } = useAppSelector((state) => state.modelSlice);

  const { batchJobId, sourceId } = useParams();

  useEffect(() => {
    if (token && batchJobId && sourceId && selectedModelId) {
      dispatch(getBatchRecord({ batchJobId: batchJobId, sourceId: sourceId }));
    }
  }, [batchJobId, sourceId, token, selectedModelId]);

  useEffect(() => {
    if (token && batchJobId && getListViewLoading === "idle") {
      dispatch(getBatchRecordList(batchJobId));
    }
  }, [batchJobId, token, getListViewLoading]);

  useEffect(() => {
    if (batchJobId) {
      dispatch(getBatchJobById(batchJobId));
    }
  }, [batchJobId]);

  useEffect(() => {
    if (selectedModelId) {
      dispatch(setSelectedModelId(selectedModelId));
    }
  }, [selectedModelId]);

  useEffect(() => {
    if (getListViewLoading === "rejected") {
      navigate(`/batchProcess`);
    }
  }, [getListViewLoading]);

  usePostUpdateNavigation("batchProcess", sourceId, batchJobId);
  useGroundTruthDataEffects();
  useListViewEffects(sourceId);

  const { onLeftChevronClick, onRightChevronClick } = useNavigationHandlers(
    "batchProcess",
    batchJobId,
  );
  const { onSaveClick } = useSaveHandler(batchJobId);

  return (
    <Column spacingInset={"500 400 0 400"} spacing={"none"}>
      <BreadcrumbGroup>
        <Breadcrumb onClick={() => navigate(`/batchProcess`)}>Batch Process</Breadcrumb>
        <Breadcrumb onClick={() => navigate(`/batchProcess/${batchJobId}`)}>
          {selectedModel.name} - Processed
        </Breadcrumb>
        <Breadcrumb>{sourceId}</Breadcrumb>
      </BreadcrumbGroup>
      {selectedModelId && (
        <ReviewHeader
          onLeftChevronClick={onLeftChevronClick}
          onRightChevronClick={onRightChevronClick}
          onSaveClick={onSaveClick}
          showMoveToNextToggle={true}
        />
      )}
      <Divider></Divider>
      <Row
        spacingInset={"0"}
        widths={["35%", "fit", "fill"]}
        alignmentVertical="top"
        spacing={"none"}
      >
        <ReviewText />
        <div className="audit-review-split-line"></div>
        <Column height={"76vh"} overflowY="auto">
          <ReviewTable />
        </Column>
      </Row>
      <Divider />
    </Column>
  );
};

export default BatchRecordReview;
